var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.675,
    height: 25.675,
    viewBox: "0 0 25.675 25.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2685",
    "data-name": "Ellipse 2685",
    cx: 12.837,
    cy: 12.837,
    r: 12.837,
    transform: "translate(0 0)",
    fill: "#19a857"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_53330",
    "data-name": "Path 53330",
    d: "M11.777,16.956a1.2,1.2,0,0,1-.844-.35L7.35,13.024a1.194,1.194,0,1,1,1.689-1.689l2.7,2.7,5.129-5.641A1.194,1.194,0,1,1,18.63,10l-5.971,6.567a1.2,1.2,0,0,1-.855.391h-.028Z",
    transform: "translate(-0.133 0.061)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmark);
export default __webpack_public_path__ + "static/media/green-checkmark.78530a1a336adb74464af137db3d91fd.svg";
export { ForwardRef as ReactComponent };